class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.predictiveSearchResultsMobile = this.querySelector('#predictive-search__mobile');
    this.searchClear = this.querySelector('[data-search-clear]');
    this.form = this.querySelector('form');
    this.initEvents();
  }

  initEvents() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    if (this.searchClear) {
      this.searchClear.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.clearInput();   
      });
      this.searchClear.addEventListener('keydown', (e) => {
        e.stopPropagation();
        if(e.code.toUpperCase() === 'ENTER') this.clearInput();
      });
    }
    const inputEvents = ['focus', 'keyup'];
    inputEvents.forEach((event) => {
      this.input.addEventListener(event, (e) => {
        if(e.target.value != '') {
          if (this.searchClear)
            this.searchClear.classList.remove('hide');
          else
            this.searchClear.classList.add('hide');
          if(event == 'keyup' && e.code.toUpperCase() === 'ENTER') this.form.submit()
        }
      });
    });
  }

  clearInput() {
    this.input.value = '';
    this.searchClear.classList.add('hide');
    this.close();
    this.input.focus();
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,collection,article,page&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,body,variants.sku,author&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.predictiveSearchResultsMobile.innerHTML = resultsMarkup;
        this.open();
        if(this.predictiveSearchResults.querySelector('[data-results-banner]')) {
          this.input.setAttribute('aria-label', 'Results available');
          setTimeout(() => {
            this.input.setAttribute('aria-label', 'Search')
          }, 300)
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.classList.add('active');
    this.predictiveSearchResultsMobile.classList.add('active');
  }

  close() {
    this.predictiveSearchResults.classList.remove('active');
    this.predictiveSearchResultsMobile.classList.remove('active');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);